/**
 * Полезная площадь полки поверх кропа — серым закрыто то, где товар лежать НЕ может
 * (Дмитрий 19.10). Разметка та же, что в «Калибровке полигонов» (ShelfUsefulAreaDialog):
 * контуры в долях кропа, режим include/exclude. Серым всегда НЕполезное, при любом режиме:
 * полезная часть остаётся чистой, на ней и размечают товар.
 *
 * Слой только показывает: клики проходят насквозь в редактор под ним. `stale` — полигон полки
 * сдвинули после разметки, кроп уже другой: граница пунктиром, чтобы ей не верили на слово.
 */
import { useId, useState } from 'react';

import type { ShelfUsefulArea } from '@/api/shelfPool';

export default function UsefulAreaOverlay(
  { area, aspect }: {
    area: ShelfUsefulArea;
    /** Натуральный размер картинки, когда она вписана с полями (object-contain): слой
     *  повторяет вписывание. Без него слой растянут на весь блок картинки. */
    aspect?: { width: number; height: number } | null;
  },
) {
  const maskId = `useful-${useId().replace(/:/g, '')}`;
  const w = aspect?.width || 1;
  const h = aspect?.height || 1;
  const include = area.mode !== 'exclude';
  const points = (poly: number[][]) => poly.map(([x, y]) => `${x * w},${y * h}`).join(' ');
  return (
    <svg
      viewBox={`0 0 ${w} ${h}`}
      preserveAspectRatio={aspect ? 'xMidYMid meet' : 'none'}
      className="pointer-events-none absolute inset-0 h-full w-full"
    >
      <defs>
        {/* Маска, а не evenodd: перекрывающиеся контуры объединяются, а не вычитаются. */}
        <mask id={maskId} maskUnits="userSpaceOnUse" x={0} y={0} width={w} height={h}>
          <rect width={w} height={h} fill={include ? '#fff' : '#000'} />
          {area.polygons.map((p, i) => (
            <polygon key={i} points={points(p)} fill={include ? '#000' : '#fff'} />
          ))}
        </mask>
      </defs>
      <rect width={w} height={h} fill="rgba(71,85,105,.6)" mask={`url(#${maskId})`} />
      {area.polygons.map((p, i) => (
        <polygon key={i} points={points(p)} fill="none" stroke="#f8fafc" strokeWidth={1.5}
                 strokeDasharray={area.stale ? '6 4' : undefined} vectorEffect="non-scaling-stroke" />
      ))}
    </svg>
  );
}

/** Карточка сетки: кроп вписан (object-contain) с полями, поэтому слой берёт натуральный размер
 *  картинки и вписывается так же — иначе серое съезжает с кропа на поля. */
export function CropWithUsefulArea(
  { src, alt, className, area }: {
    src: string; alt: string; className: string; area: ShelfUsefulArea | null;
  },
) {
  const [natural, setNatural] = useState<{ width: number; height: number } | null>(null);
  return (
    <div className="relative">
      <img src={src} loading="lazy" alt={alt} className={className}
           onLoad={e => setNatural({ width: e.currentTarget.naturalWidth,
                                     height: e.currentTarget.naturalHeight })} />
      {area && natural && <UsefulAreaOverlay area={area} aspect={natural} />}
    </div>
  );
}
